/** The same hue Parley gives a name, so the glow behind a face matches it. */
export function hue(name) {
  let h = 0;
  for (const c of String(name || '')) h = (h * 31 + c.charCodeAt(0)) % 360;
  return h;
}

/** Who can be rung from the online list: online or away. Busy promised quiet. */
export function callable(person) {
  return person && (person.status === 'online' || person.status === 'away');
}